// import { WSIBClassList } from "components/WSIBClass";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBAssociationList } from "../../components/WSIBAssociationList";

export interface IWSIBAssociationListPage { }

export const WSIBAssociationListPage: FC<IWSIBAssociationListPage> = (
  props: IWSIBAssociationListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Association List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WSIBAssociationList />}
    />
  );
};
